import { render } from "./RegionalHeatImpact.vue?vue&type=template&id=a106fb92&scoped=true"
import script from "./RegionalHeatImpact.vue?vue&type=script&lang=js"
export * from "./RegionalHeatImpact.vue?vue&type=script&lang=js"

import "./RegionalHeatImpact.vue?vue&type=style&index=0&id=a106fb92&scoped=true&lang=scss"

import exportComponent from "/home/forge/prod-v5.valleymetro.org/releases/81890031/resources/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a106fb92"]])

export default __exports__